<div
  class="side-nav-container"
  data-analytics-nav="shelf-menu"
  [attr.aria-hidden]="!isSideNavOpen">
  <div class="close-button-wrapper">
    <button
      class="close-button focus-link"
      [attr.aria-label]="'nexus.side_nav.aria_labels.close' | translate"
      (click)="emitSideNavClose()">
      <rd-shared-icon
        class="close-icon"
        [iconSymbol]="'icon-close'"
        [iconTheme]="'white'"></rd-shared-icon>
    </button>
  </div>

  <div
    *ngIf="isLoggedIn$ | async"
    class="points-summary-container"
    [class.expanded]="currentOpenMenu === 'cards'">
    <div
      class="points-summary"
      *ngIf="
        (getShouldRenderPointsSummary$ | async) &&
        (pointsSummaryFacade.pointsSummary$ | async) &&
        (activePointsAccount$ | async)
      ">
      <div *ngIf="pointsSummaryFacade.pointsSummary$ | async as pointsSummary">
        <div *ngIf="activePointsAccount$ | async as activePointsAccount">
          {{ activePointsAccount?.enrollments[0].groupName }}
          <br />
          <span class="points-balance">
            {{ pointsSummary.pointsBalance | localizePointsNumber: '1.0-0' }}
            {{ (loyaltyCurrency$ | async).name }}
          </span>
        </div>
      </div>
      <button
        *ngIf="shouldRenderCardsList$ | async"
        class="card-selector-button focus-link"
        (click)="toggleMenu('cards')"
        aria-haspopup="listbox"
        [attr.aria-label]="'wl.anz.header.cards_selector' | translate"
        [attr.aria-expanded]="currentOpenMenu === 'cards'"
        [disabled]="cardSelectorDisabled">
        <span class="icon">
          <rd-shared-icon
            class="expander-arrow"
            [iconSymbol]="'icon-chevron-down'"
            [iconTheme]="'link'"></rd-shared-icon>
        </span>
      </button>
    </div>
    <ul class="card-list" *ngIf="getShouldRenderPointsSummary$ | async">
      <li
        *ngFor="
          let pointsAccount of pointsAccountFacade.pointsAccounts$ | async
        ">
        <rd-anz-card-selector
          [pointsAccount]="pointsAccount"
          [loyaltyCurrency]="loyaltyCurrency$ | async"
          (clickEvent)="click($event)"
          [active]="
            pointsAccount.id === (activePointsAccount$ | async)?.id
          "></rd-anz-card-selector>
      </li>
    </ul>
  </div>

  <div class="nav-container">
    <ul>
      <li>
        <a
          class="menu-link focus-link"
          [routerLink]="[navlinksService.home.route]"
          (click)="emitSideNavClose(); toggleMenu('home')"
          [class.active]="isActivatedChildMenuItem('')">
          {{ navlinksService.home.translationKey | translate }}
        </a>
      </li>

      <li [class.expanded]="getExpandedStatus('redeem')">
        <button
          [dataTestid]="'anz-header-menu-button-redeem'"
          class="menu-link menu-button redeem-menu focus-link"
          (click)="toggleMenu('redeem')"
          aria-haspopup="listbox"
          [attr.aria-expanded]="getExpandedStatus('redeem')">
          <span> {{ 'wl.anz.header.redeem' | translate }} </span>
          <span class="icon">
            <rd-shared-icon
              class="expander-arrow"
              [iconSymbol]="'icon-chevron-down'"
              [iconTheme]="'link'"></rd-shared-icon>
          </span>
        </button>
        <ul class="menu-button-content" aria-haspopup="listbox">
          <li *ngFor="let navLink of navlinksService.redeem">
            <a
              [dataTestid]="navLink.dataTestid"
              class="menu-link submenu-link focus-link"
              (click)="emitSideNavClose()"
              [routerLink]="[navLink.route]"
              [class.active]="isActivatedChildMenuItem(navLink.route)">
              {{ navLink.translationKey | translate }}
            </a>
          </li>
        </ul>
      </li>

      <li
        [class.expanded]="getExpandedStatus('rewards')"
        *ngIf="isLoggedIn$ | async">
        <button
          [dataTestid]="'anz-header-menu-button-my-account'"
          class="menu-link menu-button rewards-menu focus-link"
          (click)="toggleMenu('rewards')"
          aria-haspopup="listbox"
          [attr.aria-expanded]="getExpandedStatus('rewards')">
          <span class="menu-link-text">
            {{ 'wl.anz.header.rewards' | translate }}
          </span>
          <span class="icon">
            <rd-shared-icon
              class="expander-arrow"
              [iconSymbol]="'icon-chevron-down'"
              [iconTheme]="'link'"></rd-shared-icon>
          </span>
        </button>
        <ul class="menu-button-content">
          <li *ngFor="let navLink of navlinksService.rewards">
            <a
              [dataTestid]="navLink.dataTestid"
              *ngIf="!isExternalNavLink(navLink)"
              class="menu-link submenu-link focus-link"
              (click)="emitSideNavClose()"
              [routerLink]="[navLink.route]"
              [class.active]="isActivatedChildMenuItem(navLink.route)">
              {{ navLink.translationKey | translate }}
            </a>
            <a
              [dataTestid]="navLink.dataTestid"
              *ngIf="isExternalNavLink(navLink)"
              class="menu-link submenu-link focus-link"
              [href]="[navLink.route]">
              {{ navLink.translationKey | translate }}
            </a>
          </li>
        </ul>
      </li>

      <li
        *ngFor="let navLink of navlinksService.staticPages"
        class="static-page">
        <a
          *ngIf="!isExternalNavLink(navLink)"
          class="menu-link focus-link"
          (click)="emitSideNavClose()"
          [routerLink]="[navLink.route]"
          [class.active]="isActivatedChildMenuItem(navLink.route)">
          {{ navLink.translationKey | translate }}
        </a>
        <a
          *ngIf="isExternalNavLink(navLink)"
          class="menu-link focus-link"
          [href]="[navLink.route]"
          target="_blank"
          rel="noopener noreferrer">
          {{ navLink.translationKey | translate }}
        </a>
      </li>
    </ul>
  </div>

  <div class="user-action-group">
    <ng-container *ngIf="!(isLoggedIn$ | async)">
      <ng-container *ngIf="!isAnzSSOEnabled">
        <button
          [dataTestid]="'anz-header-button-activate'"
          class="user-action focus-link"
          type="button"
          (click)="emitUserAction('enroll')"
          [attr.aria-label]="
            'wl.anz.accessibility.header.activate' | translate
          ">
          {{ 'wl.anz.header.activate' | translate }}
        </button>
      </ng-container>

      <rd-shared-button
        [dataTestid]="'anz-header-button-login'"
        class="user-action login focus-link"
        [buttonContent]="loginButtonContent"
        [buttonTheme]="'primary'"
        [iconPath]="buttonIconPath"
        (clickFn)="emitUserAction('login')">
        <ng-template #loginButtonContent>
          <span>{{ 'wl.anz.header.login' | translate }}</span>
        </ng-template>
      </rd-shared-button>
    </ng-container>

    <ng-container *ngIf="isLoggedIn$ | async">
      <rd-shared-button
        [dataTestid]="'anz-header-button-logout'"
        class="user-action logout focus-link"
        [buttonContent]="logoutButtonContent"
        [buttonTheme]="'primary'"
        [iconPath]="buttonIconPath"
        (clickFn)="emitUserAction('logout')">
        <ng-template #logoutButtonContent>
          <span>{{ 'wl.anz.header.logout' | translate }}</span>
        </ng-template>
      </rd-shared-button>
      <!-- <button
        class="user-action focus-link"
        type="button"
        (click)="emitUserAction('logout')"
      >
        {{ 'wl.anz.header.logout' | translate }}
      </button> -->
    </ng-container>
  </div>
</div>
